// extracted by css-extract-rspack-plugin
export default {"button-text":"ButtonText_button-text__qdQtd"};